import type { MappedProductVariant, ProductHit } from '../types';
import { SORT_INDEX_PLP } from './filters';

export const getSortUrlValueFromIndex = (index: string) => SORT_INDEX_PLP.items.find(i => i.value === index)?.urlValue;

export const getSortIndexFromUrlValue = (urlValue: string) =>
    SORT_INDEX_PLP.items.find(i => i.urlValue === urlValue)?.value;

export const getSortLabelFromIndex = (index: string) => SORT_INDEX_PLP.items.find(i => i.value === index)?.label;

export const getDefaultCategories = (product: ProductHit | MappedProductVariant) => {
    const primaryCategoryId = product.primary_category_id;

    const categories = product.categories?.find(category => category.find(c => c.id === primaryCategoryId));

    if (!categories) {
        return [];
    }

    if (primaryCategoryId === categories?.[0].id) {
        return categories.slice().reverse() ?? [];
    }

    return categories.slice();
};
